export default "__VITE_ASSET__DJwx52JZ__"